"use client";

import { CurrencyIcon } from "@workspace/frontend-ui";
import type { FC } from "react";

const NO_CURRENCY_PLACEHOLDER = "—";

type Props = {
  currency?: string;
};

const CurrencyOptionIcon: FC<Props> = ({ currency }) => {
  if (!currency)
    return <span className="text-xs">{NO_CURRENCY_PLACEHOLDER}</span>;

  return <CurrencyIcon currency={currency} className="size-4!" />;
};

export default CurrencyOptionIcon;
